import { render, staticRenderFns } from "./ScoringProfilesModelEdit.vue?vue&type=template&id=2daa2862&scoped=true"
import script from "./ScoringProfilesModelEdit.vue?vue&type=script&lang=js"
export * from "./ScoringProfilesModelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa2862",
  null
  
)

export default component.exports